import { render, staticRenderFns } from "./Glasses.vue?vue&type=template&id=c54188da&"
import script from "./Glasses.vue?vue&type=script&lang=js&"
export * from "./Glasses.vue?vue&type=script&lang=js&"
import style0 from "./Glasses.vue?vue&type=style&index=0&id=c54188da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports